<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button router-direction="root" routerLink="/login">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center">{{"sign-up-page.registration" | translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <logo></logo>
  <language-switcher></language-switcher>
  <form *ngIf="signupFormGroup" [formGroup]="signupFormGroup">
    <ion-item class="input-field">
      <ion-input type="text" data-cy="username"

                 [errorText]="(usernameIsFree?'sign-up-page.username-policy':'sign-up-page.username-is-taken') | translate"
                 [label]="'login-page.username' | translate" labelPlacement="floating" [clearInput]="true"
                 [formControl]="username"></ion-input>
    </ion-item>
    <ion-item class="input-field">
      <ion-input
        [errorText]="(emailIsUsed?'sign-up-page.email-is-used':'sign-up-page.insert-valid-email') | translate"
        data-cy="email"
        [label]="'sign-up-page.email' | translate" labelPlacement="floating" [clearInput]="true"
        type="email" [formControl]="email"></ion-input>
    </ion-item>
    <ion-button [routerLink]="'/reset-password/'+email.value" *ngIf="emailIsUsed" color="primary" expand="full">
      {{"login-page.forgot-password" | translate}}
    </ion-button>
    <ion-item class="input-field" *ngIf="!emailIsUsed && usernameIsFree">
      <ion-input type="password" [errorText]="'sign-up-page.password-policy' | translate" data-cy="password"
                 [label]="'sign-up-page.password' | translate" labelPlacement="floating" [clearInput]="true"
                 [formControl]="password"></ion-input>
    </ion-item>
    <ion-item class="input-field" *ngIf="!emailIsUsed && usernameIsFree">
      <ion-input type="password" [errorText]="'sign-up-page.password-does-not-match' | translate"
                 data-cy="repeat-password" [label]="'sign-up-page.repeat-password' | translate"
                 labelPlacement="floating" [clearInput]="true" [formControl]="confirmPassword"></ion-input>
    </ion-item>
    <br>
    <p class="notice" *ngIf="isValid()">{{"sign-up-page.accept-privacy"|translate}}
      <a
        [href]='"sign-up-page.link.privacy."+(isIos?"ios":"android")|translate'>{{"sign-up-page.privacy"|translate}}</a>
    </p>
    <ion-button (click)="onSignup()" [disabled]="!isValid()" color="primary" expand="full" data-cy="signup">
      <ion-icon name="send" slot="start"></ion-icon>
      {{"sign-up-page.register" | translate}}
    </ion-button>
    <ion-button (click)="onTestUser()" *ngIf="!isProd()" fill="clear">
      <ion-icon name="beer" slot="icon-only"></ion-icon>
    </ion-button>
  </form>
</ion-content>
